import {GxRadio, GxTabPanel} from '@garpix/garpix-web-components-react';
import React, {FC, useEffect, useState} from 'react';
import cnBind from 'classnames/bind';
import dayjs from 'dayjs';
import classNames from 'classnames';
import {useStoreon} from 'storeon/react';
import 'react-responsive-modal/styles.css';
import { Events, State } from '@/interfaces';
import Button from '../../../../../components/Button';
import useModalFlag from '../../../../../hooks/useModalFlag';
import {NAME_TYPES_CERTIFICATE, TYPES_CERTIFICATE,} from '../../../../Certificates/const';
import Pagination from '../../../../../components/Pagination';
import ModalActivateCertificate from '../../ModalActivateCertificate';
import styles from '../styles/index.module.scss';
import {TYPE_USER} from '../../../../../const';
import ReturnCertificate from '../../ReturnCertificate';
import { LIMIT, SORT_ITEMS, SORT_ITEMS_TYPE } from './const';
import { ICertificateInfo } from './interface';

interface ICertificatesPanel {
  userData: Record<string, any> | null;
}

const CertificatesPanel: FC<ICertificatesPanel> = ({ userData }) => {
  const { flag, setModalFlag } = useModalFlag();
  const {
    dispatch,
    certificatesUser,
    currentUser,
  } = useStoreon<State, Events>('certificatesUser', 'currentUser');


  const [activePage, setActivePage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(certificatesUser.count);
  const [activeItem, setActiveItem] = useState<SORT_ITEMS_TYPE>(SORT_ITEMS_TYPE.TUBE);
  const { flag: modalReturn, setModalFlag: toggleModalReturn } = useModalFlag();
  const [certificateInfo, setCertificateInfo] = useState<ICertificateInfo | null>(null);

  const cn = cnBind.bind(styles);

  const handleChangePage = (page: number) => {
    setActivePage(page);
    dispatch('certificatesUser/get', {
      customer_id: userData?.id,
      page,
      limit: LIMIT,
      side: activeItem,
    });
  };

  const changeItemSort = (id: number) => {
    setCertificateInfo(null);
    setActiveItem(id);
    setActivePage(1);
    dispatch('certificatesUser/get', {
      customer_id: userData?.id,
      page: 1,
      limit: LIMIT,
      side: id,
    });
  };

  useEffect(() => {
    if (userData && !!userData.id) {
      dispatch('certificatesUser/get', {
        customer_id: userData.id,
        page: 1,
        limit: LIMIT,
        side: activeItem,
      });
    }
  }, [userData]);

  useEffect(() => {
    if (certificatesUser && certificatesUser.count > 0) {
      setTotalPages(certificatesUser.count);
    } else {
      setTotalPages(1);
    }
  }, [certificatesUser]);

  const getResourceText = (item: any) => {
    if (item.side === 2 && item.rent_pay_count > 0) return `${item.remaining_rent_pays} ар.`;
    if (item.side === 1) return `${item.remaining_minutes_fly} мин.`;
    if (item.side === 2) return `${item.remaining_sets_wave} сет.`;
    const parts = [];
    if (item.remaining_minutes_fly) parts.push(`${item.remaining_minutes_fly} мин.`);
    if (item.remaining_sets_wave)    parts.push(`${item.remaining_sets_wave} сет.`);
    return parts.join(' / ') || '—';
  };

  return (
    <>
      <GxTabPanel name='certificates'>
        <div className={styles['certificate']}>
          <div className={styles['certificate--head']}>
            <h2 className={styles['certificate--title']}>Сертификаты</h2>
            <Button
              className={styles['certificate--btn']}
              disable={!userData}
              onClick={setModalFlag}
            >
              Активировать сертификат
            </Button>
            {(currentUser.user_status === TYPE_USER.SUPERUSER ||
              currentUser.user_status === TYPE_USER.STAFF) && (
              <Button
                className={styles['return-btn']}
                theme='btn--outline_blue'
                onClick={toggleModalReturn}
                disable={!certificateInfo}
              >
                Возврат
              </Button>
            )}
            <Button
              className={styles['onloading--btn_sm']}
              onClick={() => handleChangePage(1)}
            >
              Обновить
            </Button>
          </div>
          <div className={styles['sort-menu-cert']}>
            {SORT_ITEMS.map((item) => (
              <Button
                key={item.id}
                className={cn({
                  'sort-menu--btn': true,
                  'sort-menu--btn_active': activeItem === item.id,
                })}
                theme='btn--transparent_link'
                onClick={() => changeItemSort(item.id)}
              >
                {item.title}
              </Button>
            ))}
          </div>
          {certificatesUser.count === 0 ? (
            <p className={styles['info']}>Сертификаты отсутствуют...</p>
          ) : (
            <div className={styles['table']}>
              <table>
                <thead>
                  <tr>
                    <th>Номер-серия</th>
                    <th>Название</th>
                    <th>Действителен до</th>
                    <th>Цена</th>
                    <th>Ден. экв.</th>
                    <th>Ресурс</th>
                    <th>Статус</th>
                  </tr>
                </thead>
                <tbody>
                  {certificatesUser.results.map(
                    (item) => (
                      <tr key={item.id}>
                        <td className={styles['table--name']}>
                          {(currentUser.user_status === TYPE_USER.SUPERUSER ||
                            currentUser.user_status === TYPE_USER.STAFF) && (
                            <GxRadio
                              name='deposit'
                              checked={
                                certificateInfo
                                  ? certificateInfo.data.id === item.id
                                  : false
                              }
                              onClick={() =>
                                setCertificateInfo({
                                  data: item,
                                  type: activeItem,
                                })
                              }
                            />
                          )}
                          {item.number_series}
                        </td>
                        <td>{item.title}</td>
                        <td>
                          {item.date_validity
                            ? dayjs(item.date_validity).format('YYYY.MM.DD')
                            : '-'}
                        </td>
                        <td>{Math.trunc(Number(item.price_paid)).toLocaleString()}</td>
                        <td>
                          {Math.trunc(
                            item.current_price_by_equivalent
                          ).toLocaleString()}
                        </td>
                        <td>{getResourceText(item)}</td>
                        <td>
                          <span
                            className={classNames(
                              styles['table--status'],
                              styles[
                                `table--status_${
                                  NAME_TYPES_CERTIFICATE[
                                    TYPES_CERTIFICATE[item.status]
                                  ].class
                                }`
                              ]
                            )}
                          >
                            {
                              NAME_TYPES_CERTIFICATE[
                                TYPES_CERTIFICATE[item.status]
                              ].title
                            }
                          </span>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className={styles['pagination']}>
          <Pagination
              onChange={(page: number) => handleChangePage(page)}
              total={totalPages}
              pageSize={ LIMIT }
              activePage={activePage}
          />
        </div>
      </GxTabPanel>
      {
          flag && (
              <ModalActivateCertificate
                  flag={flag}
                  onRequestClose={setModalFlag}
                  user={userData ?? {}}
                  side={activeItem}
              />
          )
      }

      {certificateInfo && (
          <ReturnCertificate
              userInfo={userData}
              flag={modalReturn}
              onRequestClose={toggleModalReturn}
              data={certificateInfo}
              userID={userData?.id}
          />
      )}
    </>
  );
};

export default CertificatesPanel;
